import GroupAdminState from "./GroupAdminState";
import {AdminActionType} from "./actions";
import {AnyAction} from "redux";

const initialState = new GroupAdminState();

const AdminReducers = (state = initialState, action: AnyAction): GroupAdminState => {

    console.info(AdminActionType[action.type] || 'INITIALIZING');
    console.dir(action);

    const actionType: AdminActionType  = action.type;

    switch (actionType) {

        case AdminActionType.SET_USER:
            return state.withUser(action.user);

        case AdminActionType.FETCH_CONTRACT_GROUPS:
            return state.withContractGroups(action.contractGroups);

        case AdminActionType.SET_SELECTED_CONTRACTGROUP:
            return state.withSelectedContractGroup(action.selectedContractGroupId);

        case AdminActionType.HIGHLIGHT_USER:
            return state.withHighlightedUser(action.highlightedUserName);

        case AdminActionType.IS_LOADING:
            return state.withIsLoading(action.isLoading);
        default:
            return state;
    }
};

export default AdminReducers;